export enum GenderEnum {
    M = 'M',
    F = 'F',
    NN = 'NN'
}
